

















































import Vue from 'vue';
export default Vue.extend({
  methods: {
    getListData(value: any) {
      let listData;
      switch (value.date()) {
        case 8:
          listData = [
            {
              name: 'Rayson',
              avatarUrl:
                'https://s3.amazonaws.com/uifaces/faces/twitter/rem/128.jpg',
            },
            {
              name: 'Ow',
              avatarUrl:
                'https://s3.amazonaws.com/uifaces/faces/twitter/nckjrvs/128.jpg',
            },
          ];
          break;
        case 10:
          listData = [
            {
              name: 'Akmal',
              avatarUrl:
                'https://d3iw72m71ie81c.cloudfront.net/3fa3b0c2-df93-4962-a3d9-7cad201135b3-jpg',
            },
            {
              name: 'John Lim',
              avatarUrl: 'https://d3iw72m71ie81c.cloudfront.net/male-8.jpg',
            },
            {
              name: 'Samathan Lee',
              avatarUrl: 'https://d3iw72m71ie81c.cloudfront.net/iris.jpg',
            },
          ];
          break;
        case 15:
          listData = [
            {
              name: 'Aisah Malik',
              avatarUrl: 'https://d3iw72m71ie81c.cloudfront.net/female-95.jpeg',
            },
            {
              name: 'Mohd. Bakul',
              avatarUrl: 'https://d3iw72m71ie81c.cloudfront.net/male-50.jpg',
            },
            {
              name: 'Sam Jega',
              avatarUrl: 'https://d3iw72m71ie81c.cloudfront.net/male-75.jpg',
            },
            {
              name: 'Najib',
              avatarUrl:
                '',
            },
            {
              name: 'Rosmah',
              avatarUrl:
                'https://memegenerator.net/img/images/50x50/7460485.jpg',
            },
            {
              name: 'Lim Chee Soong',
              avatarUrl: 'https://d3iw72m71ie81c.cloudfront.net/male-52.jpg',
            },
          ];
          break;
        default:
      }
      return listData || [];
    },
  },
});
